'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.weekly_demand_report', {
        template: '<weekly-demand-report></weekly-demand-report>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/weekly/weekly_demand_report.routes.js